import { get, post } from "./client";

export const APPLY_CHUNK_SIZE = 100;

export type ImportEntityType = "office" | "contact";
export type ScanRowStatus = "ready" | "exists" | "alias" | "deleted" | "missing";

export type ScanRow = {
  entityType: ImportEntityType;
  entityId: string;
  entityName: string;
  termId: string;
  sourceId: string;
  localeCode: string;
  translatedName: string;
  status: ScanRowStatus;
};

export type ScanCounts = {
  sourceRows: number;
  addressBookOrigin: number;
  noMatch: number;
  unsupportedEntity: number;
  blank: number;
  invalidLocale: number;
  byStatus: Record<ScanRowStatus, number>;
};

export type ScanResponse = { rows: ScanRow[]; counts: ScanCounts };

export type ApplyRow = {
  entityType: ImportEntityType;
  entityId: string;
  localeCode: string;
  translatedName: string;
};

export type ApplyRowStatus = "applied" | "skipped_exists" | "not_found" | "error";

export type ApplyRowResult = {
  entityType: ImportEntityType;
  entityId: string;
  localeCode: string;
  status: ApplyRowStatus;
  previous: string | null;
  message?: string;
};

export type ApplyResponse = { results: ApplyRowResult[]; counts: Record<ApplyRowStatus, number> };

export const nameTranslationsImportService = {
  async scan(): Promise<ScanResponse> {
    return get<ScanResponse>("/v1/wp-syncer/name-translations-import");
  },

  async apply(rows: ApplyRow[]): Promise<ApplyResponse> {
    return post<ApplyResponse>("/v1/address-book/name-translations-import/apply", { rows });
  },
};
